import { t } from 'i18next';
import { useContext } from 'react';

import OrderBySelector, {
  AvailableOrderOption,
} from '~components/OrderBySelector/OrderBySelector';

import { DriverPayQueryOrdersSort } from '../../constants';
import DriverPayQueryContext from '../../DriverPayQueryContext';

const ordersSortOptions: AvailableOrderOption<DriverPayQueryOrdersSort>[] = [
  {
    value: DriverPayQueryOrdersSort.CREATED_AT,
    label: t('dispatch.dispatch_v2.orders_sort.created_at'),
  },
  {
    value: DriverPayQueryOrdersSort.COMPANY_LEGAL_NAME,
    label: t('dispatch.dispatch_v2.orders_sort.company_legal_name'),
  },
  {
    value: DriverPayQueryOrdersSort.ACCOUNT_NAME,
    label: t('dispatch.dispatch_v2.orders_sort.account_name'),
  },
  {
    value: DriverPayQueryOrdersSort.FRIENDLY_ORDER_ID,
    label: t('dispatch.dispatch_v2.orders_sort.friendly_order_id'),
  },
];

export default function OrderSelectorCTA() {
  const { ordersSort, applyOrdersSort } = useContext(DriverPayQueryContext);

  return (
    <OrderBySelector
      onChange={applyOrdersSort}
      order={ordersSort}
      orderOptions={ordersSortOptions}
    />
  );
}
